module.exports = __webpack_public_path__ + "r-v3/img/translation_ZH-TW.0d805b96.png";